module.exports = __webpack_public_path__ + "static/img/TAIRON-AH-MU.eda632e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TAIRON-AH-MU.jpg
// module id = 5qax
// module chunks = 0